import { aesUtil, encryptService } from "./encrypt-service";
import instance from "./instance";

export const getPersonalData = async (data, businessLine = null) => {
  data["LOB"] = "TR";
  return instance.post(
    businessLine
      ? `/${businessLine}/travel/getTravelPersonal`
      : "/travel/getTravelPersonal",

    { ...data, infoFlag: "false" },
    { headers: { "Content-Type": "application/json" } }
  );
};
export const getTravelProposal = async (data, businessLine = null) => {
  return instance.post(
    businessLine
      ? `/${businessLine}/travel/getTravelProposal`
      : "/travel/getProposalDev",
    data,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const getTravelFeatures = async (data, businessLine = null) => {
  return instance.post(
    businessLine
      ? `/${businessLine}/travel/getTravelFeatureDescription`
      : "/travel/getTravelFeatureDescription",
    data,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const searchQuotation = async (data, businessLine = null) => {
  const encID = aesUtil.encrypt(process.env.REACT_APP_ENC_VERSION, data.IDNO);
  return instance.post(
    businessLine
      ? `/${businessLine}/travel/searchQuotation`
      : "/travel/searchQuotation",
    data,
    {
      headers: { "Content-Type": "application/json", Auth_token: encID },
    }
  );
};

export const createTravelQoutation = async (data, businessLine = null) => {
  return instance.post(
    businessLine
      ? `/${businessLine}/travel/getTravelCreateQuotation`
      : "/travel/createQuotationDev",
    data,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};
export const getFlightDetails = async (data) => {
  // return {status:200,data:{
  //     "flightList": [
  //         {
  //             "departureTime": "05:35:00.0000000",
  //             "departureAirportIataCode": "RUH",
  //             "departureAirportCityName": "Riyadh",
  //             "carrierFsCode": "SV",
  //             "flightNumber": "1035",
  //             "arrivalDate": "04/05/2022",
  //             "carrierName": "Saudia",
  //             "arrivalAirportCityName": "Jeddah",
  //             "arrivalTime": "11:55:00.0000000",
  //             "departureAirportCountryName": "Saudi Arabia",
  //             "arrivalAirportIataCode": "JFK",
  //             "departureDate": "04/05/2022",
  //             "arrivalAirportCountryName": "Jeddah",
  //             "departureAirportName": "King Khalid International Airport",
  //             "arrivalAirportName": "King Fahad International Airport"
  //         }
  //     ],
  //     "resultCode": "S",
  //     "resultMessage": "SUCCESS"
  // }};
  return instance.post(
    "/flightDelay/getFlightsByNumber",
    { ...data, infoFlag: "false" },
    { headers: { "Content-Type": "application/json" } }
  );
};
export const getFlightProposal = async (data, businessLine = null) => {
  // return {
  //     status:200,
  //     data: {
  //           resultCode: "S",
  //           resultMessage: "SUCCESS",
  //           proposalCode: "7257",
  //           quoteList: [
  //             {
  //               coverOptionCode: "1",
  //               periodCovered: "30",
  //               coverAmount: "1000.0",
  //               paymentDetails: [
  //                 {
  //                   amountType: "PLFEE",
  //                   amountTypeDesc: "Policy Fee",
  //                   amountValue: "25",
  //                 },
  //                 {
  //                   amountType: "VATABLE",
  //                   amountTypeDesc: "Vatable Amount",
  //                   amountValue: "291.19",
  //                 },
  //                 {
  //                   amountType: "VATAMT",
  //                   amountTypeDesc: "Vat Amount",
  //                   amountValue: "47.43",
  //                 },
  //                 {
  //                   amountType: "GRNDTOT",
  //                   amountTypeDesc: "Grand total Amount - Payment Amount",
  //                   amountValue: "363.62",
  //                 },
  //                 {
  //                   amountType: "VATRATE",
  //                   amountTypeDesc: "Vat Rate",
  //                   amountValue: "15",
  //                 },
  //                 {
  //                   amountType: "QTEPRM",
  //                   amountTypeDesc: "Quotation Premium",
  //                   amountValue: "291.19",
  //                 },
  //               ],
  //             },
  //             {
  //               coverOptionCode: "2",
  //               periodCovered: "60",
  //               coverAmount: "1000.0",
  //               paymentDetails: [
  //                 {
  //                   amountType: "PLFEE",
  //                   amountTypeDesc: "Policy Fee",
  //                   amountValue: "25",
  //                 },
  //                 {
  //                   amountType: "VATABLE",
  //                   amountTypeDesc: "Vatable Amount",
  //                   amountValue: "126.66",
  //                 },
  //                 {
  //                   amountType: "VATAMT",
  //                   amountTypeDesc: "Vat Amount",
  //                   amountValue: "22.75",
  //                 },
  //                 {
  //                   amountType: "GRNDTOT",
  //                   amountTypeDesc: "Grand total Amount - Payment Amount",
  //                   amountValue: "174.41",
  //                 },
  //                 {
  //                   amountType: "VATRATE",
  //                   amountTypeDesc: "Vat Rate",
  //                   amountValue: "15",
  //                 },
  //                 {
  //                   amountType: "QTEPRM",
  //                   amountTypeDesc: "Quotation Premium",
  //                   amountValue: "126.66",
  //                 },
  //               ],
  //             },
  //             {
  //               coverOptionCode: "3",
  //               periodCovered: "90",
  //               coverAmount: "1000.0",
  //               paymentDetails: [
  //                 {
  //                   amountType: "PLFEE",
  //                   amountTypeDesc: "Policy Fee",
  //                   amountValue: "25",
  //                 },
  //                 {
  //                   amountType: "VATABLE",
  //                   amountTypeDesc: "Vatable Amount",
  //                   amountValue: "68.38",
  //                 },
  //                 {
  //                   amountType: "VATAMT",
  //                   amountTypeDesc: "Vat Amount",
  //                   amountValue: "14.01",
  //                 },
  //                 {
  //                   amountType: "GRNDTOT",
  //                   amountTypeDesc: "Grand total Amount - Payment Amount",
  //                   amountValue: "107.39",
  //                 },
  //                 {
  //                   amountType: "VATRATE",
  //                   amountTypeDesc: "Vat Rate",
  //                   amountValue: "15",
  //                 },
  //                 {
  //                   amountType: "QTEPRM",
  //                   amountTypeDesc: "Quotation Premium",
  //                   amountValue: "68.38",
  //                 },
  //               ],
  //             },
  //           ],
  //           flightDetalis: {
  //             departureAirportIataCode: "RUH",
  //             departureAirportName: null,
  //             departureAirportCityName: null,
  //             departureAirportCountryName: null,
  //             departureDate: "24/05/2022",
  //             departureTime: "14:00",
  //             arrivalAirportIataCode: "JED",
  //             arrivalAirportName: null,
  //             arrivalAirportCityName: null,
  //             arrivalAirportCountryName: null,
  //             arrivalDate: "24/05/2022",
  //             arrivalTime: "15:45",
  //           },
  //           mileage: "160",
  //         }
  // }
  return instance.post("/flightDelay/getFlightPriceDetails", data, {
    headers: { "Content-Type": "application/json" },
  });
};
export const createFlightQoutation = async (data) => {
  return instance.post("/flightDelay/getCreateQuoteDetails", data, {
    headers: { "Content-Type": "application/json" },
  });
};
export const createMultiPolicySinglePayment = async (
  data,
  businessLine = null
) => {
  return instance.post(
    businessLine
      ? `/${businessLine}/travel/multiPolicySinglePayment`
      : "/travel/multiPolicySinglePayment",
    data,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const sendOTP = async (data) => {
  return instance.post("/travel/sendOTP", data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const verifyOTP = async (data) => {
  return instance.post("/travel/validateOTP", data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const validatePromoCode = async (data, businessLine = null) => {
  return instance.post(
    businessLine
      ? `/${businessLine}/travel/validatePromoCode`
      : "/travel/validatePromoCode",
    data,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const sendEmail = async (data) => {
  return instance.post("/travel/sendEmailOTP", data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const verifyEmailOTP = async (data) => {
  return instance.post("/travel/validateEmailOTP", data, {
    headers: { "Content-Type": "application/json" },
  });
};


export const travelPolicyDocument = async (data) => {
  return instance.post("/travel/travel-policy-document", data, {
    headers: { "Content-Type": "application/json" },
  });
};


export const createTamaraSession = async (data) => {};

export const getCardPayment = async (data) => {};

export const getSadadPayment = async (data) => {};
